import React, { useEffect, useState } from 'react';
import PageHeader from 'components/common/PageHeaderBack';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  Button,
  Modal,
  Col,
  Row,
  Table,
  Spinner,
  Tabs,
  Tab
} from 'react-bootstrap';
import ProcessTimeLine from './ProcessTimeLine';
import ProcessTimeLineExpo from './ProcessTimeLineExpo';
import ProcessTimeLineFrete from './ProcessTimeLineFrete';
import ProcessFollow from './ProcessFollow';
import SubtleBadge from 'components/common/SubtleBadge';
import api from 'helpers/api';
import { useParams } from 'react-router-dom';
import classNames from 'classnames';
import IconButton from 'components/common/IconButton';
import { faDownload, faFileImport } from '@fortawesome/free-solid-svg-icons';
import { DownloadHS, Download, newDowload } from 'helpers/utils';
import Flex from 'components/common/Flex';
import { getIdUsuario } from 'helpers/auth';
import { opera } from 'is_js';
import CustoItens from './CustoItens';
var jszip = require('jszip');
var saveAs = require('file-saver');
import * as XLSX from 'xlsx';
import TrackingMap from './TrackingMap';

const ProcessDetails = () => {
  const { id } = useParams();
  const [modalShowArquivo, setModalShowArquivo] = React.useState(false);
  const [modalShowCusto, setModalShowCusto] = React.useState(false);
  const [modalShowCustoiLog, setModalShowCustoiLog] = React.useState(false);
  const [modalShowCustoItensiLog, setModalShowCustoItensiLog] =
    React.useState(false);
  const [showModal, setShowModal] = useState(false);
  const [showModalTracking, setShowModalTracking] = useState(false);
  const [existeArquivos, setExisteArquivos] = useState(false);
  const [existeCusto, setExisteCusto] = useState(false);
  const [existeCustoItens, setExisteCustoItens] = useState(false);
  const [realizouConsulta, setRealizouConsulta] = useState(false);
  const [possuiTracking, setPossuiTracking] = useState(false);
  const [operacao, setOperacao] = React.useState('');
  const [totalGeralCustos, setTotalGeralCustos] = React.useState('');
  const [totalGeralRecebido, setTotalGeralRecebido] = React.useState('');
  const [dataProcesso, setDataProcesso] = useState([]);
  const [dataTracking, setDataTracking] = useState([]);
  const [dataFollowUp, setDataFollowUp] = useState([]);
  const [dataFiles, setDataFiles] = useState([]);
  const [dataCusto, setDataCusto] = useState([]);
  const [custoTotal, setCustoTotal] = useState([]);
  const [dadosTransbordo, setDataTransbordo] = useState([]);
  const [dataCustoTotal, setDataCustoTotal] = useState([]);
  const [aberturaProcesso, setAberturaProcesso] = useState([]);
  const [prontidao, setProntidao] = useState([]);
  const [coleta, setColeta] = useState([]);
  const [embarqueInicial, setEmbarqueInicial] = useState([]);
  const [descarga, setDescarga] = useState([]);
  const [dta, setDTA] = useState([]);
  const [dataTrackingWorld, setDataTrackingWorld] = useState([]);
  const [isDownloading, setisDownloading] = React.useState(false);
  const [isExpo, setExpo] = React.useState(false);
  const [isLoading, setLoadingFile] = React.useState(false);
  const [dataCustoItens, setDataCustoItens] = useState([]);
  const [dataCustoSubItens, setDataCustoSubItens] = useState([]);
  var split = id.split('&');
  const [selectAll, setSelectAll] = useState(true);
  const allPositions = [];
  const [selectedColumns, setSelectedColumns] = useState({
    AdicaoNumero: true,
    OrdemItem: true,
    Codigo: true,
    Descricao: true,
    Ncm: true,
    Unidade: true,
    Quantidade: true,
    pesoliquidounitario: true,
    PesoLiquido: true,
    PrecoUnitario: true,
    FobMEValor: true,
    razaosocial_emp: true,
    Frete: true,
    Seguro: true,
    CIFValor: true,
    iialiquota: true,
    IIBase: true,
    IIValor: true,
    ipialiquota: true,
    ipiBase: true,
    IPI: true,
    pisaliquota: true,
    pisbase: true,
    pis: true,
    confinsaliquota: true,
    confinsBase: true,
    COFINS: true,
    TaxaSiscomex: true,
    icmsaliquota: true
  });

  const handleColumnChange = column => {
    setSelectedColumns(prev => {
      const updatedColumns = {
        ...prev,
        [column]: !prev[column]
      };

      // Verifica se ainda há colunas selecionadas
      const anySelected = Object.values(updatedColumns).some(
        selected => selected
      );
      setSelectAll(!anySelected); // Atualiza o estado de "Selecionar Todos"

      return updatedColumns;
    });
  };

  const columnLabels = {
    AdicaoNumero: 'Adicao Número',
    OrdemItem: 'Ordem',
    Codigo: 'Código',
    Descricao: 'Descrição',
    Ncm: 'NCM',
    Unidade: 'Unidade',
    Quantidade: 'Quantidade',
    pesoliquidounitario: 'P. Líq. Unit.',
    PesoLiquido: 'P. Líquido',
    PrecoUnitario: 'Preço Unitário',
    FobMEValor: 'MERCADORIA',
    razaosocial_emp: 'EXPORTADOR',
    Frete: 'FRETE',
    Seguro: 'SEGURO',
    CIFValor: 'VALOR ADUANEIRO',
    iialiquota: '% II',
    IIBase: 'BASE II',
    IIValor: 'II',
    ipialiquota: '% IPI',
    ipiBase: 'BASE IPI',
    IPI: 'IPI',
    pisaliquota: '% PIS',
    pisbase: 'BASE PIS',
    pis: 'PIS',
    confinsaliquota: '% COFINS',
    confinsBase: 'BASE COFINS',
    COFINS: 'COFINS',
    TaxaSiscomex: 'TAXA SISCOMEX',
    icmsaliquota: '% ICMS'
  };

  const exportToExcel = () => {
    const dados = combineData(dataCustoItens, dataCustoSubItens);
    const columnsToExport = Object.keys(selectedColumns).filter(
      col => selectedColumns[col]
    );

    const exportData = dados.map(item => {
      return columnsToExport.reduce((obj, key) => {
        const value = item[key];

        // Verifica se o campo é NCM e mantém o formato original
        if (key === 'NCM') {
          obj[columnLabels[key]] = value; // Mantém o valor original
        } else if (typeof value === 'string' && value.includes('.')) {
          // Remove o ponto e substitui a vírgula por um ponto para o Excel
          obj[columnLabels[key]] =
            parseFloat(value.replace(/\./g, '').replace(',', '.')) || value;
        } else {
          // Converte o valor para número, caso seja numérico
          obj[columnLabels[key]] =
            typeof value === 'number' ? value : parseFloat(value) || value;
        }
        return obj;
        return obj;
      }, {});
    });

    const worksheet = XLSX.utils.json_to_sheet(exportData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Dados');

    // Gera um arquivo Excel
    XLSX.writeFile(workbook, 'custos.xlsx');
  };

  const handleSelectAllChange = event => {
    const isChecked = event.target.checked;
    setSelectAll(isChecked);
    setSelectedColumns(prev => {
      const updatedColumns = {};
      Object.keys(prev).forEach(key => {
        updatedColumns[key] = isChecked; // Define todas as colunas para o estado do checkbox
      });
      return updatedColumns;
    });
  };

  const parseDateString = dateString => {
    const [day, month, year] = dateString.split('/'); // Exemplo: "31/12/2023"
    return new Date(`${year}-${month}-${day}`); // Converte para YYYY-MM-DD
  };

  useEffect(() => {
    if (getIdUsuario() === null) {
      window.location.href = '/';
    }

    setOperacao(split[0]);
    if (split[0] === 'E') {
      setExpo(true);
    }
    // if (split[1] !== '') {
    const getProcess = async () => {
      setRealizouConsulta(true);

      try {
        const result = await api.get(`/api/follownewpg/${id}`);
        setDataProcesso(result.data.cabecalho);        
        setDataFollowUp(result.data.followup);
        if (result.data.cabecalho[0].situacao_viagem > 0) {
          setPossuiTracking(true);
          if (result.data.mapa.length > 0) {
            setDataTrackingWorld(result.data.mapa[0].dados);
          }
        } else {
          setPossuiTracking(false);
        }
        if (split[0] === 'A') {         
          // setDataFollowUp(result.data.followup);
          setAberturaProcesso(result.data.tracking[0].abertura);
          setProntidao(result.data.tracking[0].prontidao);
          setColeta(result.data.tracking[0].coleta);
          setEmbarqueInicial(result.data.tracking[0].embarqueinicial);
          setDataTracking(result.data.tracking);
          setDataTransbordo(result.data.tracking[0].transbordo);
          setDescarga(result.data.tracking[0].descarga);
          setDTA(result.data.tracking[0].dta);

          if (result.data.cabecalho[0].Situacao_Tracking_Viagens > 0) {
            setPossuiTracking(true);
            if (result.data.mapa.length > 0) {
              setDataTrackingWorld(result.data.mapa[0].dados);
            }
          } else {
            setPossuiTracking(false);
          }
        }
      } catch (err) {
      } finally {
      }
      if (split[0] === 'A') {
        // setDataTransbordo(result.data.tracking[0].transbordo);
      } else if (split[0] === 'I' || split[0] === 'E') {
        try {
          const result = await api.get(`/api/empresas/arquivos/${split[1]}`);
          if (result.data.result.length > 0) {
            setExisteArquivos(true);
            setDataFiles(result.data.result);
          }
        } catch (err) {
        } finally {
        }

        try {
          const resultCustos = await api.get(
            `/api/empresas/custosnew/${split[1]}`
          );
          if (resultCustos.data.result.length > 0) {
            setDataCusto(resultCustos.data.result);
            setExisteCusto(true);
            setDataCustoTotal(resultCustos.data.totais);

            if (resultCustos.data.totais.length > 0) {
              setTotalGeralCustos(resultCustos.data.totalCusto[0].total);
              setTotalGeralRecebido(resultCustos.data.totalRecebido[0].total);
            }
          }
        } catch (error) {
        } finally {
        }

        try {
          const resultCustosItens = await api.get(
            `/api/empresas/custositens/${split[1]}`
          );
          if (resultCustosItens.data.result.length > 0) {
            setExisteCustoItens(true);
            setDataCustoItens(resultCustosItens.data.result);
            setDataCustoSubItens(resultCustosItens.data.sub);
          }
        } catch (error) {
        } finally {
        }
      }
      setRealizouConsulta(false);
      if (split[0] === 'A') {
        const result = await api.get(`/api/hs/arquivos/${split[1]}`);
        setDataFiles(result.data.result.recordset);
        if (result.data.result.recordset.length > 0) {
          setExisteArquivos(true);
        }

        const resultCusto = await api.get(`/api/hs/custo/${split[1]}`);
        setDataCusto(resultCusto.data.result);
        setCustoTotal(resultCusto.data.total[0].ValorTotal);
        if (resultCusto.data.total[0].ValorTotal !== null) {
          setExisteCusto(true);
        }
        // setExisteArquivos(false);
        setRealizouConsulta(false);
      }

      setRealizouConsulta(false);
    };
    getProcess();
    // }
  }, []);

  const getUrlFile = async id => {
    if (operacao[0] === 'A') {
      const result = await api.get(`/api/hs/arquivoURL/${id}`);
      DownloadHS(result.data.result, 'Teste.pdf');
    } else if (split[0] === 'I' || split[0] === 'E') {
      const result = await api.get(`/api/empresas/file/${id}`);
      Download(
        result.data.result[0].File.data,
        'application/' +
          result.data.result[0].FileName.substring(
            result.data.result[0].FileName.indexOf('.') + 1
          ),
        result.data.result[0].FileName
      );
    }
  };

  const FileDownloadFilesBlob = async (dataFile, qual) => {
    setLoadingFile(true);
    var zip = new jszip();
    dataFile.forEach(async element => {
      if (qual === 'Todos') {
        if (element['Folder'] === 'Processo' || element['Folder'] === null) {
          const blob = getAll(element['iFileSystemID']);
          var img = zip.folder('processo');
          img.file(element['FileName'], blob);
        }
        if (element['Folder'] === 'Financeiro') {
          const blob = getAll(element['iFileSystemID']);
          var img = zip.folder('financeiro');
          img.file(element['FileName'], blob);
        }
      } else if (qual === 'Processo') {
        if (element['Folder'] === 'Processo' || element['Folder'] === null) {
          const blob = getAll(element['iFileSystemID']);
          var img = zip.folder('processo');
          img.file(element['FileName'], blob);
        }
      } else if (qual === 'Financeiro') {
        if (element['Folder'] === 'Financeiro') {
          const blob = getAll(element['iFileSystemID']);
          var img = zip.folder('financeiro');
          img.file(element['FileName'], blob);
        }
      }
    });

    zip.generateAsync({ type: 'blob' }).then(function (content) {
      saveAs(content, 'arquivos.zip');
      setLoadingFile(false);
    });
  };

  const getAll = async id => {
    const result = await api.get('/api/empresas/file/' + id);
    var blob = newDowload(
      result.data.result[0].File.data,
      'application/' +
        result.data.result[0].FileName.substring(
          result.data.result[0].FileName.indexOf('.') + 1
        ),
      result.data.result[0].FileName
    );
    return blob;
  };

  function combineData(custo, subCusto) {
    const combinedData = [];

    custo.forEach(c => {
      const subs = subCusto.filter(sc => sc.AdicaoNumero === c.AdicaoNumero);
      if (subs.length > 0) {
        subs.forEach(sub => {
          combinedData.push({ ...c, ...sub }); // Combina os dados
        });
      } else {
        // Se não houver subCusto correspondente, ainda assim adiciona o custo
        combinedData.push({ ...c, Codigo: '', Descricao: '' }); // Campos do subCusto vazios
      }
    });

    return combinedData;
  }

  return (
    <>
      {realizouConsulta ? (
        <>
          <Flex justifyContent="center">
            <div className="p-2">
              <Spinner />
              <span> Aguarde carregando ...</span>
            </div>
          </Flex>
        </>
      ) : (
        <>
          {dataProcesso.map(row => {
            return (
              <>
                <PageHeader
                  title={`PROCESSO: ${row.PROCESSO}`}
                  titleTag="h5"
                  className="mb-1"
                >
                  {' '}
                  <div className="container">
                    <div className="row align-items-start mt-2">
                      <div className="col-12 col-md-6 d-flex">
                        <h6>{isExpo ? 'Importador:' : 'Exportador:'}</h6>
                        <h6 className="fw-normal ms-1">
                          {isExpo ? row.IMPORTADOR : row.EXPORTADOR}
                        </h6>
                      </div>
                    </div>

                    {operacao[0] === 'A' ? (
                      <div className="row align-items-center">
                        <div className="col-12 col-md-6 d-flex">
                          <h6>Importador:</h6>
                          <h6 className="fw-normal ms-1">{row.IMPORTADOR}</h6>
                        </div>
                        <div className="col-12 col-md-2 d-flex">
                          <h6>Modalidade:</h6>
                          <h6 className="fw-normal ms-1">{row.MODALIDADE}</h6>
                        </div>
                      </div>
                    ) : (
                      <div className="row align-items-center">
                        <div className="col-12 col-md-6 d-flex">
                          <h6>Ref. Cliente:</h6>
                          <h6
                            className="fw-normal ms-1"
                            style={{
                              overflow: 'hidden',
                              whiteSpace: 'nowrap',
                              textOverflow: 'ellipsis'
                            }}
                          >
                            {row.REFERENCIA}
                          </h6>
                        </div>
                        <div className="col-12 col-md-6 d-flex">
                          <h6>Fatura:</h6>
                          <h6 className="fw-normal ms-1">{row.FATURA}</h6>
                        </div>
                      </div>
                    )}

                    <div className="row align-items-end">
                      {operacao[0] === 'A' ? (
                        <>
                          <div className="col-12 col-md-6 d-flex">
                            <h6>Ref. Cliente:</h6>
                            <h6 className="fw-normal ms-1">{row.REFERENCIA}</h6>
                          </div>
                          <div className="col-12 col-md-2 d-flex">
                            <h6>
                              {row.MODALIDADE === 'Aereo' ? 'HAWB:' : 'HBL:'}
                            </h6>
                            <h6 className="fw-normal ms-1">
                              {row.CONHECIMENTO !== 'null'
                                ? row.CONHECIMENTO
                                : ''}
                            </h6>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="col-12 col-md-6 d-flex">
                            <h6>Modalidade:</h6>
                            <h6 className="fw-normal ms-1">{row.MODALIDADE}</h6>
                          </div>
                          <div className="col-12 col-md-2 d-flex">
                            <h6>Conhecimento:</h6>
                            <h6 className="fw-normal ms-1">
                              {row.CONHECIMENTO !== 'null'
                                ? row.CONHECIMENTO
                                : ''}
                            </h6>
                          </div>
                        </>
                      )}
                    </div>

                    <div className="row align-items-end">
                      {operacao[0] === 'A' ? (
                        <>
                          <div className="col-12 col-md-6 d-flex">
                            <h6>Viagem:</h6>
                            <h6 className="fw-normal ms-1">
                              {row.Viagem !== 'null' ? row.Viagem : ''}
                            </h6>
                          </div>
                          <div className="col-12 col-md-2 d-flex">
                            <h6>Reserva:</h6>
                            <h6 className="fw-normal ms-1">
                              {row.Numero_Controle !== 'null'
                                ? row.Numero_Controle
                                : ''}
                            </h6>
                          </div>
                        </>
                      ) : (
                        <>
                          <div className="col-4 col-md-6 d-flex">
                            <h6>{isExpo ? 'DUE:' : 'DI:'}</h6>
                            <h6 className="fw-normal ms-1">
                              {row.DI != 'null' ? row.DI : ''}{' '}
                              {row.pDITipo != 'null' ? ` - ${row.pDITipo}` : ''}
                            </h6>
                          </div>
                          <div className="col-4 col-md-2 d-flex">
                            <h6>{isExpo ? 'Chave:' : 'Protocolo:'}</h6>
                            <h6 className="fw-normal ms-1">
                              {row.protocolo_di}
                            </h6>
                          </div>
                          <div className="col-12 col-md-2 d-flex">
                            <h6>{isExpo ? 'Averbação:' : 'Registro:'}</h6>
                            <h6 className="fw-normal ms-1">
                              {isExpo
                                ? row.DT_AVERBACAO !== '00/00/0000'
                                  ? row.DT_AVERBACAO
                                  : ''
                                : row.DT_DI_REGISTRO !== '00/00/0000'
                                ? row.DT_DI_REGISTRO
                                : ''}
                            </h6>
                          </div>
                        </>
                      )}
                    </div>

                    <div className="row align-items-end">
                      {operacao[0] === 'A' ? (
                        <div className="col-12 col-md-6 d-flex">
                          <h6>Incoterm:</h6>
                          <h6 className="fw-normal ms-1">
                            {row.INCOTERM !== 'null' ? row.INCOTERM : ''}
                          </h6>
                        </div>
                      ) : (
                        <>
                          <div className="col-4 col-md-6 d-flex">
                            <h6>Canal:</h6>
                            <h6 className="fw-normal ms-1">
                              {row.CANAL !== 'null' ? row.CANAL : ''}
                            </h6>
                          </div>
                          <div className="col-4 col-md-2 d-flex">
                            <h6>Incoterm:</h6>
                            <h6 className="fw-normal ms-1">
                              {row.INCOTERM !== 'null' ? row.INCOTERM : ''}
                            </h6>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                  {existeArquivos ? (
                    <>
                      <Button
                        className="me-1 mb-1 bc-"
                        size="sm"
                        onClick={() => setModalShowArquivo(true)}
                      >
                        Arquivos
                      </Button>
                    </>
                  ) : (
                    <>
                      {/* <Button
                        className="me-1 mb-1 bc-"
                        size="sm"
                        disabled
                        onClick={() => setModalShowArquivo(true)}
                      >
                        Arquivos
                      </Button> */}
                    </>
                  )}
                  {possuiTracking ? (
                    <>
                      <Button
                        className="me-1 mb-1 bc-"
                        size="sm"
                        onClick={() => setShowModalTracking(true)}
                      >
                        Tracking
                      </Button>
                    </>
                  ) : (
                    <></>
                  )}
                  {operacao !== 'E' ? (
                    <>
                      {existeCusto ? (
                        <>
                          {operacao[0] === 'A' ? (
                            <></>
                          ) : (
                            <>
                              <Button
                                className="me-1 mb-1 bc-"
                                size="sm"
                                onClick={() =>
                                  operacao[0] === 'A'
                                    ? setModalShowCusto(true)
                                    : setModalShowCustoiLog(true)
                                }
                              >
                                Custo Nacionalização
                              </Button>
                            </>
                          )}
                        </>
                      ) : (
                        <>
                          {operacao[0] === 'A' ? (
                            <></>
                          ) : (
                            <>
                              <Button
                                className="me-1 mb-1 bc-"
                                size="sm"
                                disabled
                                onClick={() => setModalShowCusto(true)}
                              >
                                Custo Nacionalização
                              </Button>
                            </>
                          )}
                        </>
                      )}
                      {operacao[0] === 'A' ? (
                        <></>
                      ) : (
                        <>
                          {existeCustoItens ? (
                            <>
                              <Button
                                className="me-1 mb-1 bc-"
                                size="sm"
                                onClick={() => setModalShowCustoItensiLog(true)}
                              >
                                Custo Nacionalização por Item
                              </Button>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                      )}
                    </>
                  ) : (
                    <></>
                  )}
                </PageHeader>
                {/*Modal Arquivo*/}
                {operacao[0] === 'A' ? (
                  <>
                    <Modal
                      show={modalShowArquivo}
                      onHide={() => setModalShowArquivo(false)}
                      size="lg"
                      aria-labelledby="contained-modal-title-vcenter"
                      centered
                    >
                      <Modal.Header>
                        <Modal.Title
                          id="contained-modal-title-vcenter"
                          style={{ fontSize: '0.875rem' }}
                        >
                          Arquivos
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <Tabs
                          defaultActiveKey="processo"
                          id="uncontrolled-tab-example"
                        >
                          <Tab
                            eventKey="processo"
                            title="Processo"
                            className="p-3"
                            style={{ fontSize: '0.875rem' }}
                          >
                            <Table size="sm">
                              <thead>
                                <tr>
                                  <th style={{ fontSize: '0.875rem' }}>
                                    Data
                                    {isDownloading ? (
                                      <>
                                        <Spinner
                                          size="1rem"
                                          style={{ color: 'black' }}
                                        />
                                      </>
                                    ) : (
                                      <></>
                                    )}
                                  </th>
                                  <th style={{ fontSize: '0.875rem' }}>
                                    Descricao
                                  </th>
                                  <th
                                    style={{
                                      alignItems: 'center',
                                      textAlign: 'center',
                                      marginLeft: 'auto',
                                      marginRight: 'auto',
                                      fontSize: '0.875rem'
                                    }}
                                  >
                                    Download
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {dataFiles
                                  .sort(
                                    (a, b) =>
                                      parseDateString(b.DataArquivo) -
                                      parseDateString(a.DataArquivo)
                                  )
                                  .map(row => {
                                    return (
                                      <>
                                        <tr key={row.IdArquivo}>
                                          <td style={{ fontSize: '0.75rem' }}>
                                            {row.DataArquivo}
                                          </td>
                                          <td style={{ fontSize: '0.75rem' }}>
                                            {row.Descricao}
                                          </td>
                                          <td
                                            style={{
                                              display: 'flex',
                                              alignItems: 'center',
                                              textAlign: 'center',
                                              fontSize: '0.75rem'
                                            }}
                                          >
                                            {' '}
                                            <IconButton
                                              size="sm"
                                              alt="Baixar Arquivo"
                                              aria-label="Baixar Arquivo"
                                              onClick={() =>
                                                getUrlFile(
                                                  split[0] === 'I' ||
                                                    split[0] === 'E'
                                                    ? row.idarquivo
                                                    : // : operacao[0] === 'T'
                                                      //   ? `${row.DCM_COD}&${row.ADF_COD_SEQ}&${row.FIL_COD}`
                                                      row.IdArquivo
                                                )
                                              }
                                              style={{
                                                marginLeft: 'auto',
                                                marginRight: 'auto'
                                              }}
                                            >
                                              <FontAwesomeIcon
                                                icon={faDownload}
                                              />
                                            </IconButton>
                                          </td>
                                        </tr>
                                      </>
                                    );
                                  })}
                              </tbody>
                            </Table>
                          </Tab>
                        </Tabs>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          onClick={() => setModalShowArquivo(false)}
                          size="sm"
                        >
                          Fechar
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </>
                ) : (
                  <>
                    <Modal
                      show={modalShowArquivo}
                      onHide={() => setModalShowArquivo(false)}
                      size="lg"
                      aria-labelledby="contained-modal-title-vcenter"
                      centered
                    >
                      <Modal.Header>
                        <Modal.Title
                          id="contained-modal-title-vcenter"
                          style={{ fontSize: '0.875rem' }}
                        >
                          Arquivos
                        </Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <>
                          <IconButton
                            size="sm"
                            alt="Baixar Arquivo"
                            aria-label="Baixar Arquivo"
                            onClick={() =>
                              FileDownloadFilesBlob(dataFiles, 'Todos')
                            }
                            style={{
                              marginLeft: 'auto',
                              marginRight: 'auto'
                            }}
                          >
                            Baixar Todos(Processo / Financeiro)
                            <FontAwesomeIcon icon={faDownload} />
                          </IconButton>
                          {isLoading ? (
                            <>
                              <Spinner
                                style={{ color: 'black' }}
                                size="0.2rem"
                              />

                              <span
                                style={{ color: 'black', fontSize: '0.75rem' }}
                              >
                                Aguarde....
                              </span>
                            </>
                          ) : (
                            <></>
                          )}
                        </>
                        <Tabs
                          defaultActiveKey="processo"
                          id="uncontrolled-tab-example"
                        >
                          <Tab
                            eventKey="processo"
                            title="Processo"
                            className="p-3"
                            style={{ fontSize: '0.875rem' }}
                          >
                            <Table size="sm">
                              <thead>
                                <tr>
                                  <th style={{ fontSize: '0.875rem' }}>
                                    Data
                                    {isDownloading ? (
                                      <>
                                        <Spinner
                                          size="1rem"
                                          style={{ color: 'black' }}
                                        />
                                      </>
                                    ) : (
                                      <></>
                                    )}
                                  </th>
                                  <th style={{ fontSize: '0.875rem' }}>
                                    Descricao
                                  </th>
                                  <th
                                    style={{
                                      alignItems: 'center',
                                      textAlign: 'center',
                                      marginLeft: 'auto',
                                      marginRight: 'auto',
                                      fontSize: '0.875rem'
                                    }}
                                  >
                                    Download
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {dataFiles
                                  .filter(arq => arq.Folder !== 'Financeiro')
                                  .sort(
                                    (a, b) =>
                                      parseDateString(b.data) -
                                      parseDateString(a.data)
                                  )
                                  .map(row => {
                                    return (
                                      <>
                                        <tr key={row.iFileSystemID}>
                                          <td style={{ fontSize: '0.75rem' }}>
                                            {row.data}
                                          </td>
                                          <td style={{ fontSize: '0.75rem' }}>
                                            {row.FileName}
                                          </td>
                                          <td
                                            style={{
                                              display: 'flex',
                                              alignItems: 'center',
                                              textAlign: 'center',
                                              fontSize: '0.75rem'
                                            }}
                                          >
                                            {' '}
                                            <IconButton
                                              size="sm"
                                              alt="Baixar Arquivo"
                                              aria-label="Baixar Arquivo"
                                              onClick={() =>
                                                getUrlFile(
                                                  split[0] === 'I' ||
                                                    split[0] === 'E'
                                                    ? row.iFileSystemID
                                                    : // : operacao[0] === 'T'
                                                      //   ? `${row.DCM_COD}&${row.ADF_COD_SEQ}&${row.FIL_COD}`
                                                      row.IdLogistica_House
                                                )
                                              }
                                              style={{
                                                marginLeft: 'auto',
                                                marginRight: 'auto'
                                              }}
                                            >
                                              <FontAwesomeIcon
                                                icon={faDownload}
                                              />
                                            </IconButton>
                                          </td>
                                        </tr>
                                      </>
                                    );
                                  })}
                              </tbody>
                            </Table>
                          </Tab>
                          <Tab
                            eventKey="financeiro"
                            title="Financeiro"
                            className="p-3"
                            style={{ fontSize: '0.875rem' }}
                          >
                            <Table size="sm">
                              <thead>
                                <tr>
                                  <th style={{ fontSize: '0.875rem' }}>
                                    Data
                                    {isDownloading ? (
                                      <>
                                        <Spinner
                                          size="1rem"
                                          style={{ color: 'black' }}
                                        />
                                      </>
                                    ) : (
                                      <></>
                                    )}
                                  </th>
                                  <th style={{ fontSize: '0.875rem' }}>
                                    Descricao
                                  </th>
                                  <th
                                    style={{
                                      alignItems: 'center',
                                      textAlign: 'center',
                                      marginLeft: 'auto',
                                      marginRight: 'auto',
                                      fontSize: '0.875rem'
                                    }}
                                  >
                                    Download
                                  </th>
                                </tr>
                              </thead>
                              <tbody>
                                {dataFiles
                                  .filter(arq => arq.Folder === 'Financeiro')
                                  .sort(
                                    (a, b) =>
                                      parseDateString(b.data) -
                                      parseDateString(a.data)
                                  )
                                  .map(row => {
                                    return (
                                      <>
                                        <tr key={row.iFileSystemID}>
                                          <td style={{ fontSize: '0.75rem' }}>
                                            {row.data}
                                          </td>
                                          <td style={{ fontSize: '0.75rem' }}>
                                            {row.FileName}
                                          </td>
                                          <td
                                            style={{
                                              display: 'flex',
                                              alignItems: 'center',
                                              textAlign: 'center',
                                              fontSize: '0.75rem'
                                            }}
                                          >
                                            {' '}
                                            <IconButton
                                              size="sm"
                                              alt="Baixar Arquivo"
                                              aria-label="Baixar Arquivo"
                                              onClick={() =>
                                                getUrlFile(
                                                  split[0] === 'I' ||
                                                    split[0] === 'E'
                                                    ? row.iFileSystemID
                                                    : // : operacao[0] === 'T'
                                                      //   ? `${row.DCM_COD}&${row.ADF_COD_SEQ}&${row.FIL_COD}`
                                                      row.IdLogistica_House
                                                )
                                              }
                                              style={{
                                                marginLeft: 'auto',
                                                marginRight: 'auto'
                                              }}
                                            >
                                              <FontAwesomeIcon
                                                icon={faDownload}
                                              />
                                            </IconButton>
                                          </td>
                                        </tr>
                                      </>
                                    );
                                  })}
                              </tbody>
                            </Table>
                          </Tab>
                        </Tabs>
                      </Modal.Body>
                      <Modal.Footer>
                        <Button
                          onClick={() => setModalShowArquivo(false)}
                          size="sm"
                        >
                          Fechar
                        </Button>
                      </Modal.Footer>
                    </Modal>
                  </>
                )}

                {/*Modal Numerário Headsoft*/}
                <Modal
                  show={modalShowCusto}
                  onHide={() => setModalShowCusto(false)}
                  size="lg"
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                >
                  <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                      Numerário
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Table size="sm">
                      <thead>
                        <tr>
                          <th>Taxa</th>
                          <th>Sigla</th>
                          <th>Valor</th>
                          <th>Fator Conversão</th>
                          <th>Valor Convertido</th>
                        </tr>
                      </thead>
                      <tbody>
                        {dataCusto.map(row => {
                          return (
                            <>
                              <tr key={row.Nome}>
                                <td>{row.Nome}</td>
                                <td>{row.Sigla}</td>
                                <td style={{ textAlign: 'end' }}>
                                  {row.Valor_Recebimento_Total}
                                </td>
                                <td style={{ textAlign: 'end' }}>
                                  {row.Conversao}
                                </td>
                                <td style={{ textAlign: 'end' }}>
                                  {row.ValorTotal}
                                </td>
                              </tr>
                            </>
                          );
                        })}
                        <tr key="1">
                          <td style={{ fontWeight: 'bold' }} colSpan="4">
                            Total
                          </td>
                          <td style={{ textAlign: 'end' }}>{custoTotal}</td>
                        </tr>
                      </tbody>
                    </Table>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button onClick={() => setModalShowCusto(false)} size="sm">
                      Fechar
                    </Button>
                  </Modal.Footer>
                </Modal>
                {/*Modal Custo ilog*/}
                <Modal
                  show={modalShowCustoiLog}
                  onHide={() => setModalShowCustoiLog(false)}
                  size="xs"
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                >
                  <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                      Custos do Processo
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Table
                      size="xs"
                      style={{
                        borderCollapse: 'collapse',
                        fontSize: '.7rem'
                        // color: '#000'
                      }}
                    >
                      <tr
                        style={{
                          fontWeight: 'bold',
                          backgroundColor: '#e63757',
                          color: '#fff'
                        }}
                      >
                        <td>RELAÇÃO DE DESPESAS</td>
                        <td>VALOR EM R$</td>
                      </tr>
                      <tr
                        style={{
                          fontWeight: 'bold',
                          backgroundColor: '#e63757',
                          color: '#fff'
                        }}
                      >
                        <td>TRIBUTOS</td>
                        <td>
                          {dataCustoTotal
                            .filter(orders => orders.Grupo === 'Tributos')
                            .map(row => {
                              return <>{row.total}</>;
                            })}
                        </td>
                      </tr>
                      {dataCusto
                        .filter(orders => orders.Grupo === 'Tributos')
                        .map(row => {
                          return (
                            <tr key={row.Id}>
                              <td>{row.Descricao}</td>
                              <td>{row.DespesaHistoricoValorAtualizado}</td>
                            </tr>
                          );
                        })}
                      {dataCustoTotal.filter(
                        orders => orders.Grupo === 'Despesas de Embarque'
                      ).length > 0 ? (
                        <>
                          <tr
                            style={{
                              fontWeight: 'bold',
                              backgroundColor: '#e63757',
                              color: '#fff'
                            }}
                          >
                            <td>DESPESAS DE EMBARQUE</td>
                            <td>
                              {dataCustoTotal
                                .filter(
                                  orders =>
                                    orders.Grupo === 'Despesas de Embarque'
                                )
                                .map(row => {
                                  return (
                                    <span
                                      style={{
                                        fontWeight: 'bold',
                                        color: '#fff'
                                      }}
                                      key={row.total}
                                    >
                                      {row.total}
                                    </span>
                                  );
                                })}
                            </td>
                          </tr>
                        </>
                      ) : (
                        <></>
                      )}

                      {dataCusto
                        .filter(
                          orders => orders.Grupo === 'Despesas de Embarque'
                        )
                        .map(row => {
                          return (
                            <tr key={row.Id}>
                              <td>{row.Descricao}</td>
                              <td>{row.DespesaHistoricoValorAtualizado}</td>
                            </tr>
                          );
                        })}

                      {dataCusto.filter(
                        orders => orders.Grupo === 'Custos Portuários'
                      ).length > 0 ? (
                        <>
                          <tr
                            style={{
                              fontWeight: 'bold',
                              backgroundColor: '#e63757',
                              color: '#fff'
                            }}
                          >
                            <td>CUSTOS PORTUÁRIOS</td>
                            <td>
                              {dataCustoTotal
                                .filter(
                                  orders => orders.Grupo === 'Custos Portuários'
                                )
                                .map(row => {
                                  return <>{row.total}</>;
                                })}
                            </td>
                          </tr>
                          {dataCusto
                            .filter(
                              orders => orders.Grupo === 'Custos Portuários'
                            )
                            .map(row => {
                              return (
                                <tr key={row.Id}>
                                  <td>{row.Descricao}</td>
                                  <td>{row.DespesaHistoricoValorAtualizado}</td>
                                </tr>
                              );
                            })}
                        </>
                      ) : (
                        <></>
                      )}

                      <tr
                        style={{
                          fontWeight: 'bold',
                          backgroundColor: '#e63757',
                          color: '#fff'
                        }}
                      >
                        <td>SERVIÇOS</td>
                        <td>
                          {dataCustoTotal
                            .filter(orders => orders.Grupo === 'Serviço')
                            .map(row => {
                              return <>{row.total}</>;
                            })}
                        </td>
                      </tr>
                      {dataCusto
                        .filter(orders => orders.Grupo === 'Serviço')
                        .map(row => {
                          return (
                            <tr key={row.Id}>
                              <td>{row.Descricao}</td>
                              <td>{row.DespesaHistoricoValorAtualizado}</td>
                            </tr>
                          );
                        })}

                      <tr
                        style={{
                          fontWeight: 'bold',
                          backgroundColor: '#e63757',
                          color: '#fff'
                        }}
                      >
                        <td>OUTRAS DESPESAS</td>
                        <td>
                          {dataCustoTotal
                            .filter(
                              orders => orders.Grupo === 'Outras Despesas'
                            )
                            .map(row => {
                              return <>{row.total}</>;
                            })}
                        </td>
                      </tr>
                      {dataCusto
                        .filter(orders => orders.Grupo === 'Outras Despesas')
                        .map(row => {
                          return (
                            <tr key={row.Id}>
                              <td>{row.Descricao}</td>
                              <td>{row.DespesaHistoricoValorAtualizado}</td>
                            </tr>
                          );
                        })}
                      <tr rowSpan="2">
                        <td colSpan="1">&nbsp;</td>
                      </tr>
                      <tr style={{ fontWeight: 'bold' }}>
                        <td>Total Geral dos Custos</td>
                        <td>{totalGeralCustos}</td>
                      </tr>
                      <tr style={{ fontWeight: 'bold' }}>
                        <td>Total do Adiantamento Solicitado</td>
                        <td>{totalGeralCustos}</td>
                      </tr>
                      <tr style={{ fontWeight: 'bold' }}>
                        <td>Total do Adiantamento Recebido</td>
                        <td>{totalGeralRecebido}</td>
                      </tr>
                    </Table>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      onClick={() => setModalShowCustoiLog(false)}
                      size="sm"
                    >
                      Fechar
                    </Button>
                  </Modal.Footer>
                </Modal>
                {/*Modal Custo Itens ilog*/}
                <Modal
                  show={modalShowCustoItensiLog}
                  onHide={() => setModalShowCustoItensiLog(false)}
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                  size="xl"
                >
                  <Modal.Header>
                    <Modal.Title id="contained-modal-title-vcenter">
                      Custos do Itens &nbsp;
                      <IconButton
                        size="sm"
                        alt="Voltar"
                        aria-label="Voltar"
                        className="mt"
                      >
                        <FontAwesomeIcon
                          title="Exportar xlsx"
                          icon={faFileImport}
                          // onClick={() => exportToExcel()} />
                          onClick={() => setShowModal(true)}
                        />
                      </IconButton>
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body style={{ maxHeight: '90vh', overflowY: 'auto' }}>
                    <Table
                      size="small"
                      style={{
                        borderCollapse: 'collapse',
                        fontSize: '.7rem',
                        // color: '#000',
                        width: '100%' // A tabela ocupa toda a largura do modal
                      }}
                    >
                      <thead>
                        <tr
                          style={{
                            fontWeight: 'bold',
                            backgroundColor: '#e63757',
                            color: '#fff'
                          }}
                        >
                          {/* Cabeçalhos da tabela */}
                          <td
                            style={{
                              textAlign: 'center',
                              fontSize: '10px',
                              width: '70px',
                              color: '#fff'
                            }}
                          >
                            POSIÇÃO
                          </td>
                          <td
                            style={{
                              textAlign: 'center',
                              fontSize: '10px',
                              width: '100px',
                              color: '#fff'
                            }}
                          >
                            CÓDIGO
                          </td>
                          <td
                            style={{
                              textAlign: 'center',
                              fontSize: '10px',
                              width: '500px',
                              color: '#fff'
                            }}
                          >
                            DESCRIÇÃO
                          </td>
                          <td
                            style={{
                              textAlign: 'center',
                              fontSize: '10px',
                              width: '200px',
                              whiteSpace: 'nowrap',
                              color: '#fff'
                            }}
                          >
                            EXPORTADOR
                          </td>
                          <td
                            style={{
                              textAlign: 'center',
                              fontSize: '10px',
                              width: '70px',
                              whiteSpace: 'nowrap',
                              color: '#fff'
                            }}
                          >
                            NCM
                          </td>
                          <td
                            style={{
                              textAlign: 'center',
                              fontSize: '10px',
                              width: '70px',
                              whiteSpace: 'nowrap',
                              color: '#fff'
                            }}
                          >
                            UN
                          </td>
                          <td
                            style={{
                              textAlign: 'center',
                              fontSize: '10px',
                              width: '70px',
                              whiteSpace: 'nowrap',
                              color: '#fff'
                            }}
                          >
                            QTD
                          </td>
                          <td
                            style={{
                              textAlign: 'center',
                              fontSize: '10px',
                              width: '70px',
                              whiteSpace: 'nowrap',
                              color: '#fff'
                            }}
                          >
                            P. LÍQ. UNIT.
                          </td>
                          <td
                            style={{
                              textAlign: 'center',
                              fontSize: '10px',
                              width: '70px',
                              whiteSpace: 'nowrap',
                              color: '#fff'
                            }}
                          >
                            P. LÍQ. TOTAL
                          </td>
                          <td
                            style={{
                              textAlign: 'center',
                              fontSize: '10px',
                              width: '70px',
                              whiteSpace: 'nowrap',
                              color: '#fff'
                            }}
                          >
                            VAL. UNIT.
                          </td>
                          <td
                            style={{
                              textAlign: 'center',
                              fontSize: '10px',
                              width: '70px',
                              whiteSpace: 'nowrap',
                              color: '#fff'
                            }}
                          >
                            FRETE
                          </td>
                          <td
                            style={{
                              textAlign: 'center',
                              fontSize: '10px',
                              width: '70px',
                              whiteSpace: 'nowrap',
                              color: '#fff'
                            }}
                          >
                            SEGURO
                          </td>
                          <td
                            style={{
                              textAlign: 'center',
                              fontSize: '10px',
                              width: '150px',
                              whiteSpace: 'nowrap',
                              color: '#fff'
                            }}
                          >
                            VALOR ADUANEIRO
                          </td>
                          <td
                            style={{
                              textAlign: 'center',
                              fontSize: '10px',
                              width: '50px',
                              whiteSpace: 'nowrap',
                              color: '#fff'
                            }}
                          >
                            % II
                          </td>
                          <td
                            style={{
                              textAlign: 'center',
                              fontSize: '10px',
                              width: '70px',
                              whiteSpace: 'nowrap',
                              color: '#fff'
                            }}
                          >
                            BASE II
                          </td>
                          <td
                            style={{
                              textAlign: 'center',
                              fontSize: '10px',
                              width: '70px',
                              whiteSpace: 'nowrap',
                              color: '#fff'
                            }}
                          >
                            II
                          </td>
                          <td
                            style={{
                              textAlign: 'center',
                              fontSize: '10px',
                              width: '70px',
                              whiteSpace: 'nowrap',
                              color: '#fff'
                            }}
                          >
                            % IPI
                          </td>
                          <td
                            style={{
                              textAlign: 'center',
                              fontSize: '10px',
                              width: '70px',
                              whiteSpace: 'nowrap',
                              color: '#fff'
                            }}
                          >
                            BASE IPI
                          </td>
                          <td
                            style={{
                              textAlign: 'center',
                              fontSize: '10px',
                              width: '70px',
                              whiteSpace: 'nowrap',
                              color: '#fff'
                            }}
                          >
                            IPI
                          </td>
                          <td
                            style={{
                              textAlign: 'center',
                              fontSize: '10px',
                              width: '70px',
                              whiteSpace: 'nowrap',
                              color: '#fff'
                            }}
                          >
                            % PIS
                          </td>
                          <td
                            style={{
                              textAlign: 'center',
                              fontSize: '10px',
                              width: '70px',
                              whiteSpace: 'nowrap',
                              color: '#fff'
                            }}
                          >
                            BASE PIS
                          </td>
                          <td
                            style={{
                              textAlign: 'center',
                              fontSize: '10px',
                              width: '70px',
                              whiteSpace: 'nowrap',
                              color: '#fff'
                            }}
                          >
                            PIS
                          </td>
                          <td
                            style={{
                              textAlign: 'center',
                              fontSize: '10px',
                              width: '70px',
                              whiteSpace: 'nowrap',
                              color: '#fff'
                            }}
                          >
                            % COFINS
                          </td>
                          <td
                            style={{
                              textAlign: 'center',
                              fontSize: '10px',
                              width: '90px',
                              whiteSpace: 'nowrap',
                              color: '#fff'
                            }}
                          >
                            BASE COFINS
                          </td>
                          <td
                            style={{
                              textAlign: 'center',
                              fontSize: '10px',
                              width: '70px',
                              whiteSpace: 'nowrap',
                              color: '#fff'
                            }}
                          >
                            COFINS
                          </td>
                          <td
                            style={{
                              textAlign: 'center',
                              fontSize: '10px',
                              width: '110px',
                              whiteSpace: 'nowrap',
                              color: '#fff'
                            }}
                          >
                            TAXA SISCOMEX
                          </td>
                          <td
                            style={{
                              textAlign: 'center',
                              fontSize: '10px',
                              width: '70px',
                              whiteSpace: 'nowrap',
                              color: '#fff'
                            }}
                          >
                            % ICMS
                          </td>
                          <td
                            style={{
                              textAlign: 'center',
                              fontSize: '10px',
                              width: '70px',
                              whiteSpace: 'nowrap',
                              color: '#fff'
                            }}
                          >
                            VAL. TOTAL
                          </td>
                        </tr>
                      </thead>
                      <tbody>
                        {dataCustoItens.map((row, index) => {
                          return (
                            <>
                              <CustoItens
                                key={index}
                                index={index + 1}
                                custos={row}
                                subCusto={dataCustoSubItens}
                              />
                            </>
                          );
                        })}
                      </tbody>
                    </Table>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      onClick={() => setModalShowCustoItensiLog(false)}
                      size="sm"
                    >
                      Fechar
                    </Button>
                  </Modal.Footer>
                </Modal>
                {/*Modal Selecionar colunas*/}
                <Modal show={showModal} onHide={() => setShowModal(false)}>
                  <Modal.Header closeButton>
                    <Modal.Title>Selecionar Colunas para Exportar</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    <Row>
                      <Col xs={12}>
                        <div className="form-check">
                          <input
                            type="checkbox"
                            className="form-check-input"
                            checked={selectAll}
                            onChange={handleSelectAllChange}
                            id="selectAll"
                          />
                          <label
                            className="form-check-label ms-2"
                            htmlFor="selectAll"
                          >
                            Selecionar Todas
                          </label>
                        </div>
                      </Col>
                      {Object.keys(selectedColumns).map(column => (
                        <Col xs={6} key={column}>
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              checked={selectedColumns[column]}
                              onChange={() => handleColumnChange(column)}
                              id={column}
                            />
                            <label
                              className="form-check-label ms-2"
                              htmlFor={column}
                            >
                              {columnLabels[column]}
                            </label>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </Modal.Body>
                  <Modal.Footer>
                    <Button
                      variant="secondary"
                      onClick={() => setShowModal(false)}
                    >
                      Cancelar
                    </Button>
                    <Button variant="primary" onClick={() => exportToExcel()}>
                      Confirmar
                    </Button>
                  </Modal.Footer>
                </Modal>
                {/*Modal Tracking*/}
                <Modal
                  show={showModalTracking}
                  onHide={() => setShowModalTracking(false)}
                  aria-labelledby="contained-modal-title-vcenter"
                  centered
                  size="xl"
                >
                  <div className="relative flex flex-col items-center justify-center h-screen bg-gray-100 p-4">
                    <TrackingMap dataTrackingWorld={dataTrackingWorld} />
                  </div>
                </Modal>
              </>
            );
          })}
          {operacao[0] === 'A' ? (
            <>
              {' '}
              {/* <ProcessTimeLineFrete
                abertura={aberturaProcesso}
                prontidao={prontidao}
                coleta={coleta}
                embarqueInicial={embarqueInicial}
                dadosTransbordo={dadosTransbordo}
                descarga={descarga}
                dta={dta}
              /> */}
            </>
          ) : operacao[0] === 'I' ? (
            <>
              {' '}
              <ProcessTimeLine
                dadosProcesso={dataProcesso}
                operacao={operacao[0]}
              />
              {/* <ProcessTracking dadosTracking={dataTracking} /> */}
            </>
          ) : operacao[0] === 'E' ?(
            <>
              <ProcessTimeLineExpo
                dadosProcesso={dataProcesso}
                operacao={operacao[0]}
              />
            </>
          ):(<></>)}
          <br />
          <ProcessFollow dadosFollow={dataFollowUp} />
        </>
      )}
    </>
  );
};

export default ProcessDetails;
